import React from 'react'
import { BsGithub,BsInstagram} from 'react-icons/bs'
import {AiFillLinkedin } from 'react-icons/ai'
import {GrMail} from 'react-icons/gr'




const SocialMedia = () => {
  return (
    <div className="app__social">
        <a href="https://github.com/akshar1277" target="_blank" rel="noreferrer">
        <div>
            <BsGithub/>
        </div>
        </a>
        <a href="https://www.instagram.com/b_.akshar._/" target="_blank" rel="noreferrer">
        <div>
            <BsInstagram/>
        </div>
        </a>
        <a href="https://www.linkedin.com/in/akshar-bhalani1277/" target="_blank" rel="noreferrer">
        <div>
            <AiFillLinkedin/>
        </div>
        </a>
        <a href="mailto:bhalaniakshar1@gmail.com" target="_blank" rel="noreferrer">
        <div>
            <GrMail/>
        </div>
        </a>
    </div>
  )
}

export default SocialMedia